import { render, staticRenderFns } from "./ServiceDetails.vue?vue&type=template&id=2f530dfb&"
import script from "./ServiceDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f530dfb')) {
      api.createRecord('2f530dfb', component.options)
    } else {
      api.reload('2f530dfb', component.options)
    }
    module.hot.accept("./ServiceDetails.vue?vue&type=template&id=2f530dfb&", function () {
      api.rerender('2f530dfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/ServiceDetails.vue"
export default component.exports